<template>
  <div name="lesson-posts" class="max-h-screen">
    <div class="header-subnav-holder mb-2 pl-2 pr-0">
      <div class="mt-1" v-for="(path, index) in tabsList" :key="path.id">
        <button
          type="button"
          class="header-subnav focus:outline-none pb-2"
          @click="selectedTab = path"
          v-bind:class="[selectedTab.id === path.id ? 'selected' : '']"
        >
          {{ path.name }} <span class="text-xs text-red-500">({{ getTypeCount(path) }})</span>
        </button>
        <span v-if="index < tabsList.length - 1" class="opacity-25">|</span>
      </div>
    </div>

    <section v-if="errored" class="w-full text-center mt-6">
      <h3 class="font-bold text-xl text-action-red">
        There was an issue adding the post details.
      </h3>
      <p class="text-action-blue">
        Please try again shortly or contact us to resolve the issue.
      </p>
    </section>

    <div class="flex flex-col w-full justify-between p-0" style="height: 90vh">
      <div class="px-6  overflow-y-auto">
        <div v-for="post in orderedPosts" :key="post.identifier" class="border-b space-y-2 mt-4">
          <div class="flex items-center justify-between" v-if="canSeePost(post)">
            <h2 class="text-sm font-semibold text-gray-900 -mt-1">
              {{parsePostUser(post)}} 
            </h2>
            <small class="text-sm text-orange-500">{{ parsePostedDate(post)}}</small>
          </div>
          <div class="w-full flex justify-start items-start flex-col">
            <p class="leading-normal text-gray-600">
              {{post.detail}}
            </p>
          </div>
          <div 
          class="w-full flex justify-start items-end flex-col pb-4">
            <button
            v-if="ownsPost(post)"
              @click="deletePost(post)"
            type="button"
            class="
              text-red-500
              hover:opacity-75
              focus:outline-none
            "
          >
            <i class="fas fa-trash-alt"></i>
          </button>
          </div>
        </div>


        <template v-if="!hasResults">
                  <p  class="mt-4 text-gray-600 text-sm">
                  No posts entered. Please add a new post below.
                </p>
                </template>
      </div>

      <div class="flex w-full items-start justify-start mt-4 -ml-1 mb-0 border-t bg-gray-200">
        <form class="pl-4 pr-10 w-full"   v-on:submit.prevent="submitPost"  ref="form">
          <div class="flex flex-wrap -mx-3 mb-6">
            <div class="w-full px-3 mb-2 pt-6">
              <textarea
                class="bg-gray-100 rounded border border-gray-400 leading-normal resize-none w-full h-20 py-2 px-3 font-medium placeholder-gray-700 focus:outline-none focus:bg-white"
                name="body"
                placeholder="Add a new comment"
                v-model="postDetail"
                required
              ></textarea>
            </div>
            <div class="w-full flex items-start justify-between px-3 pl-4 pt-1 pb-2">
              <div class="text-gray-600" v-if="1==3"> 
                {{ privateTitle }}
                <button
                
              type="button"
              class="
                hover:bg-gray-400 hover:bg-opacity-50
                px-3
                py-1
                rounded
                ml-2
              "
              v-bind:class="[
                postPrivate === 1
                  ? 'bg-yellow-600 bg-opacity-75 text-white'
                  : 'bg-green-400 text-white',
              ]"
              @click="checkboxToggle()"
            >
              <i
                class="fas"
                v-bind:class="
                  postPrivate === 1 ? 'fa-lock' : 'fa-check-circle'
                "
              ></i>
            </button>
            
              </div>
              <div class="-mr-1">
                <button
                @click="submitForm()"
                  type="submit"
                  class="publish-button bg-white text-gray-700 font-medium py-1 px-4 border border-gray-400 rounded-lg tracking-wide mr-1 hover:bg-gray-100"
                >Post Comment</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { PostService } from "@/services/post.service";
import { calendarYearList } from "@/assets/js/utils";

export default {
  name: "lesson-posts",
  mixins: [],
  props: {
    lesson: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
    }),
    privateTitle() {
      return this.postPrivate === 1 ? "Post is private" : "Viewable to all teachers"
    },
    tabsList() {
      return _.orderBy(this.tabs, ["order"]);
    },
    hasResults() {
      return this.orderedPosts.length > 0;
    },
    orderedPosts() {
      var vm = this;

      var filtered = vm.posts.filter(function (post) {
        let filtered = true;
        filtered = post.type.key_value === vm.selectedTab.path;

        return filtered;
      });
      return _.orderBy(filtered, ["name", "category_id"]);
    }
  },
  mounted() {},
  data() {
    return {
      tabs: [],
      selectedTab: {},
      posts: [],
      errored: false,
      loading: false,
      isSaving: false,
      postDetail: "",
      postPrivate: 0
    };
  },
  mounted() {
    this.tabs = [
      { id: 2, name: "Teacher Feedback", path: "feedback", order: 1 },
      { id: 3, name: "Assessment for Learning", path: "afl", order: 2 },
      { id: 1, name: "Notes", path: "notes", order: 3 },
    ];

    this.selectedTab = this.tabs[0];
    this.postDetail = ""
  },
  created() {
    this.fetchPostData()
  },
  methods: {
    fetchPostData() {
      PostService.getByCourse(this.lesson.course_id)
      .then((response) => this.buildPosts(response.data.data))
      .catch((res) => {
        console.log(res);
      });
    },
    buildPosts(data) {
      let vm = this
      vm.posts = data.filter(function (post) {
        return post.post_unit.lesson_id === vm.lesson.id;
      });
    },
    canSeePost(post) {
      if (post.share_level === 0 ) { return true }

      if (post.share_level > 0) {
        return post.user_id === this.currentUser.teacherID
      }

      return false
    },
    parsePostUser(post) {
      if (post.user === undefined) {
        return "Uknown poster"
      }
      return post.user.name
    },
    parsePostedDate(post) {
      let date = moment(post.posted_date, 'YYYY-MM-DD HH:mm:ss GMT Z');
      const timestamp = date.diff(Date.now(), 'days');

      return timestamp < -7 ? date.format("Do MMMM YYYY") :  date.fromNow()
    },
    getTypeCount(tab) {
      const list = this.posts.filter(function (post) {
        return post.type.key_value === tab.path;
      });

      return list.length
    },
    checkboxToggle() {
      if (this.postPrivate === 0) {
        this.postPrivate = 1 
      } else {
        this.postPrivate = 0
      }
    },
    submitForm() {
      if (this.$refs.form.requestSubmit === undefined) {
        this.submitPost();
      } else {
        this.$refs.form.requestSubmit();
      }
    },
    submitPost() {
      if (this.postDetail.length === 0) {
        return 
      }

      this.isSaving = true;

      let calendarYear = calendarYearList().find((y) => y.current === true);
      var payload = {
        detail: this.postDetail,
        post_type_id: this.selectedTab.id,
        calendar_schoolyear: calendarYear.value,
        user_id: this.currentUser.teacherID,
        share_level: this.postPrivate,
        post_unit: {
          course_id: this.lesson.course_id,
          lesson_id: this.lesson.id,
        //  inclass: this.selectedClass.name
        }
      }

      PostService.add(payload)
          .then((response) => this.completion())
          .catch((err) => {
            this.failure(err)
          })
          .finally(() => (this.isSaving = false));
    },
    completion() {
      this.postDetail = ""
      this.fetchPostData()
    },
    failure(error) {
      this.errored = true;
      console.log(" update error " + error);
    },
    ownsPost(post) {
      if (post.user === undefined) { return false }
      return this.currentUser.teacherID === post.user.id
    },
    processDelete(post) {
    this.isSaving = true;
      PostService.delete(post)
          .then((response) => this.completion())
          .catch((err) => {
            this.failure(err)
          })
          .finally(() => (this.isSaving = false));
    },
    deletePost(post) {
      this.$swal({
        title: "Are you sure you want to delete?",
        text: "You will not be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete!",
      }).then((result) => {
        if (result) {
          this.processDelete(post);
        }
      });
  
    } 
  },
  components: {

  },
};
</script>

<style scoped>

</style>